import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import AuthContext from '../servicos/autorizacao/AuthContex';
import NavMenu from "./components/Nav";
import servicosColaborador from "../servicos/servicos-colaborador";
import { Modal } from "react-bootstrap";
import FormBoot from 'react-bootstrap/Form';
import { Form } from "semantic-ui-react";
import moment from "moment/moment";

import { ToastContainer, toast } from 'react-toastify';
import bg from '../img/bg-branco.jpeg'
import NavMobile from "./components/NavMobile";
import Salvar from "../img/svgs/Salvar";
import Cancel from "../img/svgs/Cancel";
import servicosCep from "../servicos/servicos-cep";
import { Link } from "react-router-dom";

export default function Perfil() {
  const { user } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const senha = useRef("");
  const confirmaSenha = useRef("");
  const [senhaDivergente, setSenhasDivergentes] = useState(false);
  const [usuario, setUsuario] = useState([]);
  const [dadosCep, setDadosCep] = useState([]);

  const dadosColaborador = {
    endereco: useRef(),
    bairro: useRef(),
    cep: useRef(),
    complemento: useRef(),
    numero: useRef(),
    telefone: useRef(),
  }

  useEffect(() => {
    servicosColaborador.listarUm(user?.id).then(response => {
      if (response.status === 200) {
        setUsuario(response.data);
      }
    })
  }, [user.id, showEditar]);

  const changeCep = (event) => {
    const valor = event.target.value;
    const cep = valor.replace(/\D/g, '');
    if (cep.length === 8 && /^\d+$/.test(cep)) {
      servicosCep.consultaCep(cep).then(response => {
        if (response.status === 200) {
          setDadosCep(response.data)
        }
      })
    }
  }


  const containerRef = useRef(null);
  const handleClose = () => {
    setShow(false);
    setDadosCep([]);

  }

  const handleCloseEditar = () => setShowEditar(false);

  const handleShow = () => {
    setShow(true);
  }
  const handleShowEditar = () => {
    setShowEditar(true);
    setDadosCep([]);

  }


  const alterarSenha = (e, senha, confirmaSenha) => {
    e.preventDefault();
    if (senha === confirmaSenha) {
      let confirmacao = window.confirm("Você deseja realmente alterar a senha?");
      if (confirmacao === true) {
        const data = {
          "password": senha
        }
        servicosColaborador.alterarSenha(user.id, data).then(response => {
          if (response.status === 200) {
            toast.success("Senha alterada com sucesso");
            setShow(false);
          } else {
            toast.error("Não foi possível alterar a senha!")
          }
        })
      }
    } else {
      setSenhasDivergentes(true);
    }

  }

  function formatarString(stringOriginal) {
    const stringNumerica = stringOriginal.replace(/\D/g, '');
    const stringFormatada = stringNumerica.substring(0, 5) + '-' + stringNumerica.substring(5);
    return stringFormatada;
  }
  const editarColaborador = (e) => {
    const cepFormatado = formatarString(dadosColaborador.cep?.current?.value);
    const data = {
      "endereco": dadosColaborador.endereco?.current?.value,
      "numero": Number(dadosColaborador.numero?.current?.value),
      "cep": cepFormatado,
      "bairro": dadosColaborador.bairro?.current?.value,
      "complemento": dadosColaborador.complemento?.current?.value,
      "telefone": dadosColaborador.telefone?.current?.value
    }

    servicosColaborador.editar(usuario?.id_colaborador, data).then(response => {
      if (response.status === 200) {
        toast.success("Dados alterado com sucesso!", {
          theme: "colored",
        });
        setDadosCep([]);
        handleCloseEditar(true);
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível alterar o Colaborador!", {
        theme: "colored"
      });
    })
  }
  const ModalEditarSenha = () => {
    return <>
      <Modal className=" modal-perfil" show={show} onHide={handleClose}>
        <Modal.Body >
          <div ref={containerRef}>
            <div className="d-flex justify-content-center ">
              <div>
                <FormBoot onSubmit={(e) => alterarSenha(e, senha.current.value, confirmaSenha.current.value)}>
                  <input type="text" id="username" style={{ display: 'none' }} autocomplete="username" />
                  <FormBoot.Group className="mb-3 disabled" controlId="senha">
                    <FormBoot.Label className="label-texto">Senha</FormBoot.Label>
                    <FormBoot.Control className="input-cadastro" type="password" ref={senha} name="senha" autocomplete="new-password" />
                  </FormBoot.Group>
                  <FormBoot.Group className="mb-3 disabled" controlId="confirma_senha">
                    <FormBoot.Label className="label-texto">Confirma Senha</FormBoot.Label>
                    <FormBoot.Control className="input-cadastro" type="password" ref={confirmaSenha} name="confirma_senha" autocomplete="new-password" />
                  </FormBoot.Group>
                  {senhaDivergente && <span className="text-danger">Senhas não conferem</span>} <br />
                  <div className="text-center">
                    <button className="btn-icones rounded p-1 w-25 me-3" type="submit"><Salvar /><span className=""> Alterar</span> </button>
                    <button className="btn-icones rounded p-1 w-25" onClick={handleClose}><Cancel /> Voltar</button>
                  </div>
                </FormBoot>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }

  const ModalEditar = () => {
    const endereco = {
      endereco: usuario?.endereco,
      bairro: usuario?.bairro,
      cep: usuario?.cep,
      complemento: usuario?.complemento,
      numero: usuario?.numero,
    }

    const enderecoViaCep = {
      endereco: dadosCep?.logradouro,
      bairro: dadosCep?.bairro,
      cep: dadosCep?.cep,
    }


    return <>
      <Modal className="modal-lg" show={showEditar} onHide={handleCloseEditar}>
        <Modal.Body className="" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  <Form.Field className="mx-5 ">
                    <label htmlFor="cep" className="form-label label-texto">CEP</label>
                    <input className="input-cadastro" onChange={changeCep} ref={dadosColaborador.cep} maxLength={9} placeholder="00000-000" defaultValue={enderecoViaCep?.cep ? enderecoViaCep.cep : endereco?.cep} id="cep" ></input>
                  </Form.Field>
                  <Form.Field className="mx-5">
                    <label htmlFor="telefone" className="form-label label-texto">Telefone</label>
                    <input className="input-cadastro" defaultValue={usuario?.telefone} ref={dadosColaborador.telefone} placeholder="(00) 00000-0000"></input>
                  </Form.Field>
                  <Form.Field className="mx-5 ">
                    <label htmlFor="endereco" className="form-label label-texto">Endereço</label>
                    <input className="input-cadastro" id="endereco" ref={dadosColaborador.endereco} defaultValue={enderecoViaCep?.cep ? enderecoViaCep.endereco : endereco?.endereco}></input>
                  </Form.Field>
                  <Form.Field className="mx-5 ">
                    <label htmlFor="bairro" className="form-label label-texto">Bairro</label>
                    <input className="input-cadastro" id="bairro" ref={dadosColaborador.bairro} defaultValue={enderecoViaCep?.cep ? enderecoViaCep.bairro : endereco?.bairro} ></input>
                  </Form.Field>
                  <Form.Field className="mx-5 ">
                    <label htmlFor="numero" className="form-label label-texto">Número</label>
                    <input className="input-cadastro" id="numero" ref={dadosColaborador.numero} defaultValue={enderecoViaCep?.cep ? "" : endereco?.numero}></input>
                  </Form.Field>

                  <Form.Field className="mx-5">
                    <label htmlFor="complemento" className="form-label label-texto">Complemento</label>
                    <input className="input-cadastro" id="complemento" ref={dadosColaborador.complemento} defaultValue={enderecoViaCep?.cep ? "" : endereco?.complemento}></input>
                  </Form.Field>

                  <Form.Field className="mx-5 mt-4">
                    <button type="submit" onClick={(e) => editarColaborador(e)} className="border-1 btn-icones rounded p-1 " >
                      <Salvar /><span> Salvar</span>
                    </button>
                    <button className="btn-icones border-1  rounded p-1 ms-2" onClick={handleCloseEditar}>
                      <Cancel /> <span> Voltar</span>
                    </button>
                  </Form.Field>
                </div>
              </div>
            </Form>
          </div>

        </Modal.Body>
      </Modal>
    </>
  }

  const FormatData = ({ data }) => {
    const dataf = moment(data);
    return <>{dataf.format('DD/MM/YYYY')}</>
  }

  return <>
    <ModalEditarSenha />
    <ModalEditar />
    <ToastContainer />
    <NavMenu />
    <div className="bg-perfil container rounded-5 " style={{ backgroundImage: `url(${bg})`, backgroundPosition: "center", backgroundSize: "cover" }}>
      {usuario !== null && <div className="mt-3 ms-2">
        <div className="pt-5 d-flex row">
          <span className="mt-1"><strong>Nome:</strong> {user.nome}</span>
          <span className="mt-1"><strong>E-mail:</strong> {user.email}</span>
          <span className="mt-1"><strong>CPF:</strong> {usuario?.cpf}</span>
          {/* {usuario.Cargo[0].nome_cargo !== undefined && <span className="mt-4"><strong>Cargo</strong> {usuario?.Cargo[0]?.nome_cargo}</span>}<br /> */}
          {/* {usuario?.Setor[0]?.nome_setor !== undefined && <span className="mt-4"><strong>Setor</strong> {usuario?.Setor[0]?.nome_setor}</span>}<br /> */}
          <span className="mt-1"><strong>CEP: </strong> {usuario?.cep}</span>
          <span className="mt-1"><strong>Endereço</strong> {usuario?.endereco}</span>
          <span className="mt-1"><strong>Número</strong> {usuario?.numero}</span>
          <span className="mt-1"><strong>Bairro</strong> {usuario?.bairro}</span>
          {usuario?.complemento && <span className="mt-1"><strong>Complemento</strong> {usuario?.complemento}</span>}
          <span className="mt-1"><strong>Data de Nascimento</strong> <FormatData data={usuario?.data_nascimento} /></span>
          <span className="mt-1"><strong>Data de Admissão</strong> <FormatData data={usuario?.data_admissao} /></span>
          <span className="mt-1"><strong>Telefone</strong> {usuario?.telefone}</span>
        </div>
        <button className="mt-4 mb-5 rounded p-1 border-0 bg-primary text-light" onClick={handleShow}>Alterar Senha</button>
        <button className="mt-4 mb-5 rounded p-1 border-0 bg-primary text-light ms-2" onClick={handleShowEditar}>Alterar Meus Dados</button>

      </div>}
      <div className="text-center">
        <Link className="btn-link text-center" to="/Termos" target="_blank">Termos de uso</Link>
        <p>
          LEV INTERMEDIACAO DE NEGOCIOS LTDA | CNPJ 13.054.592/0001-76
        </p>
      </div>
    </div>
    <NavMobile />
  </>
}
